export default __webpack_public_path__ + "static/media/vouchers_desk.dd9f9a42.png";